"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
var index_1 = require("../../index");
var helpers_1 = require("../../helpers");
function DroppableZone(_a) {
    var children = _a.children, _b = _a.as, Container = _b === void 0 ? "aside" : _b, style = _a.style, className = _a.className;
    var _c = (0, index_1.useDraggableList)(), direction = _c.direction, grid = _c.grid;
    return (react_1.default.createElement(react_beautiful_dnd_1.Droppable, { droppableId: "list", direction: direction }, function (provided, snapshot) {
        return (react_1.default.createElement(Container, __assign({ ref: provided.innerRef, className: className, style: __assign(__assign({}, style), (0, helpers_1.getDroppableZoneStyle)(grid, snapshot.isDraggingOver)) }, provided.droppableProps),
            children,
            provided.placeholder));
    }));
}
exports.default = DroppableZone;
//# sourceMappingURL=index.js.map